/* global axios */

import ApiClient from './ApiClient';

// ACESSO-01 (L8a): o catálogo de acesso da conta (`Acesso::CatalogoController`): os módulos, os escopos, os grupos (os
// da Powerbizz e os da conta) e os modelos, com o rótulo e a frase no idioma de quem pede. Só leitura, de todo membro.
// ACESSO-01 (L9): a gestão que as telas usam, com o corpo no nível de cima, como os controllers do L7 leem. Os papéis e
// os grupos pedem `roles:manage`. As exceções pedem `people:manage`, e o "Onde atua" pede um escopo por lista (S6).
class AcessoAPI extends ApiClient {
  constructor() {
    super('acesso', { accountScoped: true });
  }

  catalogo() {
    return axios.get(`${this.url}/catalogo`);
  }

  // O `id` de um modelo da Powerbizz é a chave dele (`administrador`, `atendente`...), que só serve para ver e duplicar.
  papeis() {
    return axios.get(`${this.url}/papeis`);
  }

  papel(id) {
    return axios.get(`${this.url}/papeis/${id}`);
  }

  criarPapel(corpo) {
    return axios.post(`${this.url}/papeis`, corpo);
  }

  atualizarPapel(id, corpo) {
    return axios.patch(`${this.url}/papeis/${id}`, corpo);
  }

  apagarPapel(id) {
    return axios.delete(`${this.url}/papeis/${id}`);
  }

  duplicarPapel(id) {
    return axios.post(`${this.url}/papeis/${id}/duplicar`);
  }

  grupos() {
    return axios.get(`${this.url}/grupos`);
  }

  criarGrupo(corpo) {
    return axios.post(`${this.url}/grupos`, corpo);
  }

  atualizarGrupo(id, corpo) {
    return axios.patch(`${this.url}/grupos/${id}`, corpo);
  }

  apagarGrupo(id) {
    return axios.delete(`${this.url}/grupos/${id}`);
  }

  // `pessoaId` é o id do usuário, como em /agents/:id.
  excecoes(pessoaId) {
    return axios.get(`${this.url}/pessoas/${pessoaId}/excecoes`);
  }

  criarExcecao(pessoaId, corpo) {
    return axios.post(`${this.url}/pessoas/${pessoaId}/excecoes`, corpo);
  }

  apagarExcecao(pessoaId, id) {
    return axios.delete(`${this.url}/pessoas/${pessoaId}/excecoes/${id}`);
  }

  ondeAtua(pessoaId) {
    return axios.get(`${this.url}/pessoas/${pessoaId}/onde_atua`);
  }

  trocarCaixas(pessoaId, ids) {
    return axios.patch(`${this.url}/pessoas/${pessoaId}/onde_atua/caixas`, {
      ids,
    });
  }

  // `todos` liga e desliga o "atua em todos os pipelines"; `ids` é a lista inteira dos escolhidos, e o que ficou fora sai.
  trocarFunis(pessoaId, corpo) {
    return axios.patch(
      `${this.url}/pessoas/${pessoaId}/onde_atua/funis`,
      corpo
    );
  }

  trocarApps(pessoaId, ids) {
    return axios.patch(`${this.url}/pessoas/${pessoaId}/onde_atua/apps`, {
      ids,
    });
  }
}

export default new AcessoAPI();
